<script setup>
// The bottom-left banner stack. Owns the fixed positioning that the announcement
// bar used to carry on its own root, so that the schedule-conflict banner can sit
// above it with a real 9px gap (Jack, 2026-08-20) rather than a measured offset —
// the announcement bar's height is CMS-driven and wraps differently per
// breakpoint, so anything computed from it would be wrong as often as right.
//
// Order is stacking order: the conflict banner renders first and therefore sits
// on top. Either child can be absent — the announcement bar is dismissable and
// CMS-driven, the conflict banner only appears when there IS a conflict — and
// `gap` collapses on its own when one is missing, so no case needs special
// handling.
</script>

<template>
    <!-- 67px on mobile, not the 96px this inherited from the announcement bar:
         the Back to Top button sits 22px from the bottom on the same side and is
         36px tall, so it occupies 22-58px. 58 + the stack's own 9px gap = 67,
         which clears it exactly. 96px left a 74px hole beneath the banner and
         read as floating mid-page (Jack, 2026-08-21). -->
    <div
        class="fixed bottom-[67px] left-4 right-4 md:bottom-10 md:left-10 md:right-auto z-50
            flex flex-col gap-[9px] items-stretch md:items-start
            pointer-events-none"
    >
        <TwoSixScheduleConflictBanner />
        <TwoSixAnnouncementBar />
    </div>
</template>
